import { render } from "./LzPaginatorLink.vue?vue&type=template&id=3f9aa4f6"
import script from "./LzPaginatorLink.vue?vue&type=script&lang=js"
export * from "./LzPaginatorLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__